import { render, staticRenderFns } from "./Embarcacion.vue?vue&type=template&id=b66cecfc"
import script from "./Embarcacion.vue?vue&type=script&lang=js"
export * from "./Embarcacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports